// Client for the auth service (auth/ — Better Auth on Hono), reached through
// the same origin as the console — one load balancer routes both by prefix.
import { createAuthClient } from "better-auth/react";

// NEXT_PUBLIC_: inlined at build time; a missing value fails the static
// export build, same as the console client (which reads the same var).
function apiOrigin(): string {
  const url = process.env.NEXT_PUBLIC_API_ORIGIN;
  if (!url) throw new Error("NEXT_PUBLIC_API_ORIGIN is not set");
  return url;
}

// baseURL carries the path because the server mounts routes under /auth/v1,
// not Better Auth's default /api/auth.
export const authClient = createAuthClient({ baseURL: `${apiOrigin()}/auth/v1` });

// Where emailed verification links land (the callbackURL sent with sign-up
// and send-verification-email calls). A function, not a const: window only
// exists in the browser, not at static-export prerender.
export function verifyEmailCallbackURL(): string {
  return `${window.location.origin}/verify-email`;
}

// Where emailed password-reset links land (the redirectTo sent with
// requestPasswordReset calls).
export function resetPasswordRedirectURL(): string {
  return `${window.location.origin}/reset-password`;
}
